import ApiService from '@/services/core/api.service'

const HistoryService = {
  async get (query = '') {
    return ApiService.get(`disbursement-associate/reports/document-printing?${query}`)
  },

  async post (payload) {
    return ApiService.post('disbursement-associate/reports/document-printing', payload)
  },

  async put (payload) {
    return ApiService.put(`disbursement-associate/reports/document-printing/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`disbursement-associate/reports/document-printing/${payload.id}`)
  }
}

export default HistoryService
